<template>
  <li class="list-group-item">
    <h5 class="mb-1 text-center">
      <span class="badge badge-pill badge-info mx-1">{{ order.statusStr }}</span>
      <div v-if="order.reasonForRejection">
        <span
          class="text-danger h6"
          style="cursor: pointer;"
          @click="seeReasonForRejection = !seeReasonForRejection"
        >{{ labelReasonForRejection }}</span>
        <p
          v-show="seeReasonForRejection"
          class="mb-0 h6"
          style="white-space: pre-line;"
        >{{ order.reasonForRejection }}</p>
      </div>
    </h5>
    <div class="row no-gutters">
      <div class="col-8">
        <strong>Nro. {{ order.id }}</strong>
        <p class="m-0">{{ new Date(order.createdAt).toLocaleString() }}</p>
        <strong class="my-2 font-size-up">
          {{ order.totalAmount | currency('Bs.', 2, {
          thousandsSeparator: ".",
          decimalSeparator: ",",
          symbolOnLeft: true,
          spaceBetweenAmountAndSymbol: true
          })
          }}
        </strong>
      </div>
      <div class="col-4 align-self-center justify-content-center d-flex">
        <span
          v-if="order.status !== 'R'"
          class="d-inline-block"
          tabindex="0"
          data-toggle="tooltip"
          title="Ver productos"
        >
          <button
            class="btn btn-sm btn-info mr-2"
            @click="$router.push({name: 'OrderDetail', params: {id: order.id}})"
          >
            <i style="font-size:18px" class="fas fa-clipboard-list"></i>
          </button>
        </span>
        <span v-else class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Pagar orden">
          <button
            class="btn btn-sm btn-success"
            @click="$router.push({name: 'OrderDetail', params: {id: order.id}})"
          >
            <i style="font-size:18px" class="fas fa-money-bill-wave"></i>
          </button>
        </span>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ["order"],
  data() {
    return {
      seeReasonForRejection: false
    };
  },
  computed: {
    labelReasonForRejection() {
      return this.seeReasonForRejection ? "Ocultar motivo" : "Ver motivo";
    }
  }
};
</script>

<style >
.font-size-up {
  font-size: 17px;
}
</style>